import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Plus } from '@phosphor-icons/react';
import { Button, Modal, Table } from 'app/components';
import { ACTION_ITEMS, COLUMN_CONFIG } from './constants';
import VenueModal from '../event-create/venueForm';
import { createVenue, deleteVenue, getCitiesList, getVenueList, updateVenue } from './api';

const AdminVenueList = () => {
  const [venueConfig, setVenueConfig] = useState(null);
  const [deletableVenueId, setDeletableVenueId] = useState(null);

  const { venueList, cityList } = useSelector((state) => state.adminVenueList);

  useEffect(() => {
    getVenueList();
    getCitiesList();
  }, []);

  const closeModal = () => setVenueConfig(null);

  const saveVenueDetails = (venue, cb) => {
    if (venue?._id) {
      updateVenue(venue?._id, venue, cb);
    } else createVenue(venue, cb);
  };

  const onAddVenue = (venue) => {
    saveVenueDetails(venue, () => {
      getVenueList();
      closeModal();
    });
  };

  const HeaderActionItems = (
    <Button
      size="small"
      className="ml-12"
      onClick={() => setVenueConfig({})}
      iconLeft={<Plus />}
    >
        Add New Venue
    </Button>
  );

  const onClickActionItem = (actionItem, row) => {
    if (actionItem.action === 'edit') {
      setVenueConfig(row);
    } else if (actionItem.action === 'delete') {
      setDeletableVenueId(row?._id);
    }
  };

  const onDeleteVenue = () => {
    deleteVenue(deletableVenueId, () => {
      getVenueList();
      setDeletableVenueId(null);
    });
  };

  return (
    <div className="flex flex-col gap-4 p-5 admin-events-list">
      <Table
        className="venue-list-table"
        columns={COLUMN_CONFIG}
        rows={venueList}
        hasPagination={false}
        showSearch={false}
        headerActionItems={HeaderActionItems}
        actionItems={ACTION_ITEMS}
        onClickActionItem={onClickActionItem}
      />
      {!!venueConfig && (
        <VenueModal
          primaryText={venueConfig?._id ? 'Save' : 'Add'}
          venueDetails={venueConfig}
          isModalOpen={!!venueConfig}
          cities={cityList}
          onClose={closeModal}
          onSave={onAddVenue}
        />
      )}
      <Modal
        className="delete-confirmation-modal"
        primaryText="Delete"
        size="regular"
        isOpen={!!deletableVenueId}
        onClickPrimaryCta={onDeleteVenue}
        onClickSecondaryCta={() => setDeletableVenueId(null)}
        title="Are you sure you want to delete this venue?"
      />
    </div>
  );
};

export default AdminVenueList;
